import React, {useEffect, useRef} from 'react';
import MainImage from '../../assets/Images/landing-1st-main.png';
import Arrow from '../../assets/Images/landing-f-arrow.png';
import BackArrow from '../../assets/Images/landing-3rd-arrow.png';
import {Link} from "react-router-dom";
import {
    BackArrowImage, CommentBottomBtn, CommentsContainer, CommentTopBtn,
    FirstSecArrow, FirstSection,
    RoundWrapper,
    ShiftsContainer,
    StatisticNumber,
    StatisticText, WhyUsCard
} from "./main.styles";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay} from "swiper";
import 'swiper/css';
import {Footer, CommentCard, ShiftCard} from "../../components";
import gsap from 'gsap';
import {useSelector} from "react-redux";


const Main = () => {

    const isLogged = useSelector(state => state.user.is_login);
    const splashData = useSelector(state => state.splash.splash_data);

    const commentContainerRef = useRef(null);

    useEffect(() => {
        try {
            commentContainerRef.current.firstChild.classList.add('active');
            commentContainerRef.current.childNodes[1].classList.add('next-comment');
        } catch (e) {

        }

    }, []);

    const nextComment = () => {
        let activeComment = commentContainerRef.current.querySelector('div.active');
        let nextComment = commentContainerRef.current.querySelector('div.next-comment');

        if (!nextComment) {
            return false;
        }

        gsap.to(activeComment, .5, {
            opacity: 0,
            y: -100,
            onComplete: () => {
                gsap.set(activeComment, {
                    clearProps: "all"
                });
                activeComment.classList.remove('active');
            }
        });

        gsap.to(nextComment, .5, {
            opacity: 1,
            y: -280,
            x: 0,
            onComplete: () => {
                gsap.set(nextComment, {
                    clearProps: "all"
                });
                nextComment.classList.remove('next-comment');
                nextComment.classList.add('active');

                if (nextComment.nextElementSibling) {
                    nextComment.nextElementSibling.classList.add('next-comment');
                }
            }
        });
    }

    const prevComment = () => {
        let activeComment = commentContainerRef.current.querySelector('div.active');
        let nextComment = commentContainerRef.current.querySelector('div.next-comment');
        let prevComment = activeComment.previousSibling; // be careful

        if (!prevComment) {
            return false;
        }

        if (nextComment) {
            nextComment.classList.remove('next-comment');
        }

        prevComment.classList.add('active');
        prevComment.style.opacity = '0';
        prevComment.style.transform = 'translateY(-200px)';
        activeComment.classList.remove('active');
        activeComment.classList.add('next-comment');

        gsap.from(activeComment, .5, {
            opacity: .8,
            x: 0,
            // y: 110,
            onComplete: () => {
                gsap.set(activeComment, {
                    clearProps: "all"
                });
            }
        });

        gsap.to(prevComment, .5, {
            opacity: 1,
            y: 0,
            onComplete: () => {
                gsap.set(prevComment, {
                    clearProps: "all"
                });
            }
        });
    }

    return (
        <>
            <FirstSection className='rtl mt-4'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-12 col-lg-6 col-xl-5 order-2 order-lg-1 mt-5 mt-lg-0 position-relative'>
                            <h1 className='dark-gray text-center text-lg-end'>لورم ایپسوم متن ساختگی</h1>
                            <p className='light-gray mt-5 fs-7'>
                                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
                                است
                                چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است
                            </p>
                            <div className='d-flex flex-wrap flex-md-nowrap mt-5'>
                                {
                                    isLogged ?
                                        <>
                                            <Link to='/request' className='c-btn c-btn-success flex-grow-1
                                                flex-lg-grow-0 flex-basis-100 text-center py-c-2'>ارسال درخواست</Link>

                                            <Link to='/requests' className='c-btn c-btn-gradient-warning me-md-4
                                                me-xxl-5 flex-grow-1 flex-lg-grow-0 flex-basis-100 text-center mt-4 mt-md-0 py-c-2'>مشاهده
                                                شیفت‌ها</Link>

                                        </>
                                        :
                                        <Link to='/sign-up'
                                              className='c-btn c-btn-success text-center py-c-2 flex-grow-1 flex-lg-grow-0'>ثبت
                                            نام داروساز</Link>

                                }

                            </div>
                            <FirstSecArrow src={Arrow} alt='arrow'/>
                        </div>
                        <div className='col-12 col-lg-6 col-xg-6 order-1 order-lg-2 me-lg-auto'>
                            <img className='img-fluid' src={MainImage} alt='pharmacy'/>
                        </div>
                    </div>
                </div>
            </FirstSection>
            <section className='container mt-7 mb-5'>
                <div className='px-c-lg-4 px-c-xxl-7 d-flex align-items-center justify-content-between'>
                    <div className='flex-basis-25 flex-lg-basis-0 mx-md-3 mx-lg-0'>
                        <RoundWrapper>
                            <i className='icon-drug'/>
                        </RoundWrapper>
                        <StatisticNumber>+ 500</StatisticNumber>
                        <StatisticText>داروخــانــه</StatisticText>
                    </div>
                    <div className='flex-basis-25 flex-lg-basis-0 mx-md-3 mx-lg-0'>
                        <RoundWrapper>
                            <i className='icon-band-aids'/>
                        </RoundWrapper>
                        <StatisticNumber>+ 2.5 هزار</StatisticNumber>
                        <StatisticText>شیفت تبادل شده</StatisticText>
                    </div>
                    <div className='flex-basis-25 flex-lg-basis-0 mx-md-3 mx-lg-0'>
                        <RoundWrapper>
                            <i className='icon-vaccine'/>
                        </RoundWrapper>
                        <StatisticNumber>+ 2.5 هزار</StatisticNumber>
                        <StatisticText>داروساز تایید شده</StatisticText>
                    </div>
                    <div className='flex-basis-25 flex-lg-basis-0 mx-md-3 mx-lg-0'>
                        <RoundWrapper>
                            <i className='icon-heart'/>
                        </RoundWrapper>
                        <StatisticNumber>95%</StatisticNumber>
                        <StatisticText>نظر مثبت</StatisticText>
                    </div>

                </div>
            </section>
            <section className='container-lg mt-c-5 mt-c-lg-8'>
                <div className='d-flex align-items-center justify-content-between d-lg-none rtl'>
                    <h2>جدیدترین شیفت‌ها</h2>
                    <Link to='/requests' className='success-color'>مشاهده همه شيفت‌ها</Link>
                </div>
                <h1 className='text-center d-none d-lg-block'>برخی شیفت‌های ساعات گذشته</h1>
                <p className='light-gray text-center mt-4 d-none d-lg-block'>لورم ایپسوم متن ساختگی با تولید سادگی
                    نامفهوم از صنعت چاپ و
                    با استفاده از طراحان گرافیک است</p>
                <ShiftsContainer className='mt-3'>
                    <Swiper
                        loop
                        dir='rtl'
                        autoplay={{
                            delay: 4000,
                        }}
                        breakpoints={{
                            768: {
                                slidesPerView: 2.5,
                                spaceBetween: 20,
                            },
                            1200: {
                                slidesPerView: 3,
                                spaceBetween: 20,
                            },
                            1400: {
                                slidesPerView: 4,
                                spaceBetween: 30,
                            }
                        }}
                        modules={[Autoplay]}
                        className='py-5'
                        spaceBetween={30}
                        slidesPerView={1.5}
                    >
                        {
                            splashData.shifts?.map(item => (
                                <SwiperSlide key={item.id}>
                                    <ShiftCard item={item} shiftsModalHandler={() => {
                                    }}/>
                                </SwiperSlide>
                            ))
                        }
                        {
                            splashData.shifts?.map(item => (
                                <SwiperSlide key={item.id}>
                                    <ShiftCard item={item} shiftsModalHandler={() => {
                                    }}/>
                                </SwiperSlide>
                            ))
                        }
                        {
                            splashData.shifts?.map(item => (
                                <SwiperSlide key={item.id}>
                                    <ShiftCard item={item} shiftsModalHandler={() => {
                                    }}/>
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                </ShiftsContainer>
                <div className='position-relative mt-4 mt-lg-5 d-flex text-center justify-content-center d-lg-block'>
                    <Link to='/requests' className='c-btn c-btn-success flex-grow-1 flex-md-grow-0 py-c-2'>مشاهده همه
                        شيفت‌ها</Link>
                    <BackArrowImage src={BackArrow} alt='arrow' className='d-none d-lg-inline-block'/>
                </div>
            </section>
            <section className='mt-10 rtl'>
                <div className='container'>
                    <h1 className='text-center'>چرا از فارماکار استفاده کنیم؟</h1>
                    <div className='row mt-5 mt-c-lg-7'>
                        <WhyUsCard className='col-12 col-lg-4'>
                            <span className='icon-profile-tick'>
                                <span className='path1'/>
                                <span className='path2'/>
                                <span className='path3'/>
                            </span>
                            <h2 className='mt-4'>لورم ایپسوم</h2>
                            <p className='gray-color mt-5'>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و
                                با استفاده از طراحان گرافیک
                                است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است</p>
                        </WhyUsCard>
                        <WhyUsCard className='col-12 col-lg-4'>
                            <span className='icon-shield-tick'>
                                <span className='path1'/>
                                <span className='path2'/>
                                <span className='path3'/>
                            </span>
                            <h2 className='mt-4'>لورم ایپسوم</h2>
                            <p className='gray-color mt-5'>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و
                                با استفاده از طراحان گرافیک
                                است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است</p>
                        </WhyUsCard>
                        <WhyUsCard className='col-12 col-lg-4'>
                            <span className='icon-clipboard-tick'>
                                <span className='path1'/>
                                <span className='path2'/>
                                <span className='path3'/>
                            </span>
                            <h2 className='mt-4'>لورم ایپسوم</h2>
                            <p className='gray-color mt-5'>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و
                                با استفاده از طراحان گرافیک
                                است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است</p>
                        </WhyUsCard>
                    </div>
                </div>
            </section>
            <section className='mt-10 rtl'>
                <div className='container'>
                    <CommentsContainer className='row'>
                        <div className='col-12 col-lg-4 d-flex flex-column justify-content-center '>
                            <div className='text-center text-lg-end'>
                                <h1>نظرات داروسازان <br className='d-none d-lg-inline-block'/>درباره فارماکار</h1>
                                <p className='gray-color mt-4 mb-0'>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از
                                    صنعت
                                    چاپ و با استفاده از طراحان گرافیک
                                    است</p>
                            </div>
                        </div>
                        <div className='col-12 col-lg-7 mt-c-5 mt-lg-0'>

                            <div ref={commentContainerRef} style={{height: '390px'}}>
                                <CommentCard rate={5}
                                             userName='1حمیدرضا اسدیان' userType='داروساز'
                                             userProfile='https://www.ibsaderma.fr/wp-content/uploads/2020/12/neck-and-de%CC%81collete%CC%81.jpg'
                                             userComment='لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده
                                         از طراحان گرافیک است لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است'/>

                                <CommentCard rate={4}
                                             userName='2حمیدرضا اسدیان' userType='داروساز'
                                             userProfile='https://www.ibsaderma.fr/wp-content/uploads/2020/12/neck-and-de%CC%81collete%CC%81.jpg'
                                             userComment='لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
                                         است لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است'/>

                                <CommentCard rate={4}
                                             userName='حمیدرضا اسدیان3' userType='داروساز'
                                             userProfile='https://www.ibsaderma.fr/wp-content/uploads/2020/12/neck-and-de%CC%81collete%CC%81.jpg'
                                             userComment='لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
                                         است لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است'/>


                                <CommentCard rate={4}
                                             userName='4حمیدرضا اسدیان' userType='داروساز'
                                             userProfile='https://www.ibsaderma.fr/wp-content/uploads/2020/12/neck-and-de%CC%81collete%CC%81.jpg'
                                             userComment='لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک
                                         است لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است'/>

                            </div>

                        </div>
                        <div className='col-12 col-lg-1 d-flex flex-column justify-content-center '>
                            <div className='d-flex flex-lg-column justify-content-center align-items-center'>
                                <CommentTopBtn onClick={nextComment}>
                                    <i className="icon-arrow"/>
                                </CommentTopBtn>
                                <CommentBottomBtn className='mt-lg-3' onClick={prevComment}>
                                    <i className="icon-arrow-circle-right"/>
                                </CommentBottomBtn>
                            </div>
                        </div>
                    </CommentsContainer>
                </div>
            </section>
            <Footer rootClassName='mt-0 mt-c-lg-10'/>
        </>
    );
};

export default Main;
